import { render, staticRenderFns } from "./DiscountRulesSetting.vue?vue&type=template&id=f8f675ac"
import script from "./DiscountRulesSetting.vue?vue&type=script&lang=js"
export * from "./DiscountRulesSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports